import {Organization} from '@catalyst-zero/company-schema/types/Organization'
import {lazy, useContext, useEffect} from 'react'
import {Navigate, Route, Routes, useNavigate, useParams} from 'react-router-dom'

import {FactorLibrary} from '../../../components/factor-library/factor-library'
import OrganizationContext from '../../../context/OrganizationContext'
import UserContext from '../../../context/UserContext'
import {getOrganization} from '../../../services/organization'
import {hasAssetsCategory, hasCompanyCategory, hasProductsCategory} from '../../../utils/organization'

/* istanbul ignore next */
const CompanyPage = lazy(() => import('baselineValue/company-page'))
/* istanbul ignore next */
const CzpPage = lazy(() => import('czp/products-page'))

const calculateFirstPage = (organization: Organization) => {
  if (hasCompanyCategory(organization)) return 'company'
  else if (hasProductsCategory(organization)) return 'products'
  else if (hasAssetsCategory(organization)) return 'assets'
  return ''
}

const OrganizationOrganizationId = () => {
  const {organizationId} = useParams()
  const {organization, setOrganization} = useContext(OrganizationContext)
  const user = useContext(UserContext)
  const navigate = useNavigate()

  useEffect(() => {
    if (organizationId) {
      getOrganization(organizationId)
        .then(setOrganization)
        .catch(() => navigate('/'))
    }

    return () => setOrganization(undefined)
  }, [organizationId, setOrganization])

  return organization ? (
    <Routes>
      {hasCompanyCategory(organization) && (
        <Route element={<CompanyPage organization={organization} user={user!} />} path="company/*" />
      )}
      {/* hasAssetsCategory(organization) && <Route element={<AdatPage organization={organization} />} path="assets/*" /> */}
      {hasProductsCategory(organization) && (
        <Route element={<CzpPage organization={organization} />} path="products/*" />
      )}
      <Route element={<FactorLibrary />} path="factor-library/*" />
      <Route element={<Navigate replace to={calculateFirstPage(organization)} />} path="*" />
    </Routes>
  ) : null
}

export default OrganizationOrganizationId
